<h1>WelCome To Angular</h1>
<nav class="navbar navbar-expand-lg navbar-light bg-light">
  <a class="navbar-brand" href="#">Navbar</a>
  <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent"
    aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
    <span class="navbar-toggler-icon"></span>
  </button>

  <div class="collapse navbar-collapse" id="navbarSupportedContent">
    <ul class="navbar-nav mr-auto">
      <li class="nav-item active"><a class="nav-link" routerLink=''>Home</a></li>
      <li class="nav-item"><a class="nav-link" routerLink='about'>About</a></li>
      <li class="nav-item"><a class="nav-link" routerLink='contact'>Contact</a></li>
      <li class="nav-item"><a class="nav-link" routerLink='todo'>todo</a></li>
      <li class="nav-item"><a class="nav-link" routerLink='todo1'>todo1</a></li>

      <li class="nav-item dropdown">
        <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown"
          aria-haspopup="true" aria-expanded="false">
          Dropdown
        </a>
        <div class="dropdown-menu" aria-labelledby="navbarDropdown">
          <a class="dropdown-item" href="#">Action</a>
          <a class="dropdown-item" href="#">Another action</a>
          <div class="dropdown-divider"></div>
          <a class="dropdown-item" href="#">Something else here</a>
        </div>
      </li>
      <li class="nav-item">
        <a class="nav-link disabled" href="#">Disabled</a>
      </li>
    </ul>
    <form class="form-inline my-2 my-lg-0">
      <input class="form-control mr-sm-2" type="search" placeholder="Search" aria-label="Search">
      <button class="btn btn-outline-success my-2 my-sm-0" type="submit">Search</button>
    </form>
  </div>
</nav>
<ul>
  <li><a routerLink=''>Home</a></li>
  <li><a routerLink='about'>About</a></li>
  <li><a routerLink='contact'>Contact</a></li>
  <li><a routerLink='todo'>todo</a></li>
  <li><a routerLink='todo1'>todo1</a></li>
</ul>
<!-- <app-todo></app-todo>

<app-todo1></app-todo1> -->
<router-outlet></router-outlet>
